<template>
  <div>
    <div style="margin:10px 0">
      <label>日期范围：</label>
      <!-- <a-range-picker @change="onChange" /> -->
      <a-date-picker
        style="width:140px"
        :disabledDate="disabledStartDate"
        v-model="json.StartTime"
        @change="changeStartDate"
        format="YYYY-MM-DD"
        :allowClear="false"
      />
      -
      <a-date-picker
        v-model="json.EndTime"
        :disabledDate="disabledEndDate"
        :allowClear="false"
        format="YYYY-MM-DD"
        style="width:140px;margin-right:10px"
      />
    </div>
    <div style="margin-bottom: 15px;">
      <label>有效星期：</label>
      <a-checkbox v-model="json.CheckMonday">星期一</a-checkbox>
      <a-checkbox v-model="json.CheckTuesday">星期二</a-checkbox>
      <a-checkbox v-model="json.CheckWednesday">星期三</a-checkbox>
      <a-checkbox v-model="json.CheckThursday">星期四</a-checkbox>
      <a-checkbox v-model="json.CheckFriday">星期五</a-checkbox>
      <a-checkbox v-model="json.CheckSaturday">星期六</a-checkbox>
      <a-checkbox v-model="json.CheckSunday">星期日</a-checkbox>
    </div>
    <div style="width:100%">
      <div style="float: left;">
        <label>房型价格：</label>
      </div>
      <div>
        <data-grid
          ref="dataGrid"
          class="price-table"
          :columns="priceColumns"
          :rowSelect="true"
          v-model="json.PriceCalendarInputs"
          :params="params"
          @selected="onSelectedRows"
          rowKey="RoomTypeId"
          :clearSelectedKeys="false"
          :props="{
            scroll: {
              y: 370
            }
          }"
          bordered
        >
        </data-grid>
      </div>
    </div>
  </div>
</template>
<script>
import { DataGrid } from "@/components/dataGrid";
import moment from "moment";
import { cache } from "@/utils/common";
export default {
  name: "bulkEditing",
  components: { DataGrid },
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    columns: {
      type: Array,
      default: () => []
    },
    dateRange: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      json: {
        StartTime: null,
        EndTime: null,
        CheckMonday: false,
        CheckTuesday: false,
        CheckWednesday: false,
        CheckThursday: false,
        CheckFriday: false,
        CheckSaturday: false,
        CheckSunday: false,
        IsHourRoom: false,
        Duration: 0,
        PriceCalendarInputs: [],
        RoomTypeIds: []
      },
      roomTypeList: [],
      params: {},
      selectKeys: [],
      priceColumns: [
        {
          title: "房型",
          dataIndex: "Roomtype"
        },
        {
          title: "基础价",
          dataIndex: "BasePrice",
          width: "30%"
        },
        {
          title: "设置价",
          dataIndex: "TargetPrice",
          width: "30%",
          edit: {
            type: "number"
          },
          onChange: (val, record) => {
            this.selectKeys =
              this.selectKeys && this.selectKeys.length ? this.selectKeys : [];
            if (record.BasePrice != val) {
              if (!this.selectKeys.includes(record.RoomTypeId)) {
                this.selectKeys.push(record.RoomTypeId);
              }
              this.$refs.dataGrid.setSelecteds(this.selectKeys);
            }
          },
          min: 0,
          max: 1000000
        }
      ]
    };
  },
  created() {
    this.json.StartTime = moment(this.dateRange[1].date);
    this.json.EndTime = moment(this.dateRange[this.dateRange.length - 1].date);
    this.columns.forEach(el => {
      this.json.PriceCalendarInputs.push({
        RoomTypeId: el.dataIndex,
        Roomtype: el.title,
        BasePrice: this.data[el.dataIndex],
        TargetPrice: this.data[el.dataIndex]
      });
    });
    // this.$post("Get_Select_Items", { Types: "RoomType" }).then(res => {
    //   res.Data.RoomType.forEach(item => {
    //     this.json.PriceCalendarInputs.push({
    //       RoomTypeId: item.Id,
    //       Roomtype: item.Text,
    //       BasePrice: this.data[item.Id],
    //       // setprice: String(item.Data.Price),
    //       TargetPrice: this.data[item.Id]
    //     });
    //   });
    // });
  },
  mounted() {},
  methods: {
    onSelectedRows(keys) {
      this.selectKeys = keys;
    },
    //结束时间选择范围
    disabledEndDate(endValue) {
      return endValue && endValue < this.json.StartTime.startOf("day");
    },
    disabledStartDate(current) {
      return (
        current &&
        current < moment(cache.get("user").AccountDate).startOf("day")
      );
    },
    changeStartDate(value) {
      if (this.json.EndTime && value.valueOf() > this.json.EndTime.valueOf()) {
        this.json.EndTime = value;
      }
    },
    onChange(date, dateString) {
      this.json.StartTime = dateString[0];
      this.json.EndTime = dateString[1];
    },
    onSubmitBefore() {
      if (!this.json.StartTime) {
        this.$message.info("请填写日期！");
        return false;
      } else {
        this.json.RoomTypeIds = this.selectKeys;
        return this.json;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.price-table
  /deep/.ant-table-fixed-header
  > .ant-table-content
  > .ant-table-scroll
  > .ant-table-body {
  overflow-x: hidden;
}
.price-table /deep/.data-grid-cell-edit {
  margin: 0;
}
</style>
